/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { IoNotificationsOutline } from "react-icons/io5";
import { RiMenu2Line } from "react-icons/ri";

import CatapaultLogo from "../../../assets/Logo/acte_masterclass_logo_white.png";
import Asidebar from "./asidebar";
import avatarUser from "../../../assets/avatarUser.png";
import {useDispatch, useSelector} from "react-redux";
import NotificationsDropdown from "./NotificationsDropdown";
import { notificationService } from "../../../services/notificationService/NotificationServices";
import ChatDropdown from "./ChatDropdown";
import {useNavigate} from "react-router-dom";
import {GlobalSearch} from "./GlobalSearch";
import {readNotifications} from "../../../redux/authSlice";

const Header = () => {
    const [showNotificationsDropdown, setShowNotificationsDropdown] = useState(false);
    const userProfileData = useSelector((state) => state?.auth?.userData);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleNotificationsClick = async () => {
        setShowNotificationsDropdown(!showNotificationsDropdown);
        dispatch(readNotifications());
        if (userProfileData?.unread_notifications > 0) {
            await notificationService.readAllNotifications();
        }
    };

    return (
        <>
            {/* Header for desktop start */}
            <header className="header d-lg-flex d-none position-fixed header-section">
                <div>
                    <img crossOrigin="anonymous" className="px-5 header-logo" src={CatapaultLogo} alt="Catapault" />
                </div>
                <div className="d-flex px-5">
                    <GlobalSearch />
                    <div className="d-flex gap-3 fs-4 px-2">
                        {/* <AiOutlineSearch className="header-icon" /> */}
                        {/* <HiOutlineMail className="header-icon" /> */}
                        <div className="dropdown">
                            <button
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                id="notificatioDropdown"
                                className="btn text-white fs-4 p-0  position-relative border border-0"
                                onClick={handleNotificationsClick}
                                // ref={notificationIconRef}
                            >
                                <IoNotificationsOutline className="header-icon" />
                                {userProfileData?.unread_notifications > 0 && <span className="position-absolute     noti-count top-0 start-100 translate-middle badge rounded-pill bg-danger">{userProfileData?.unread_notifications}</span>}
                            </button>
                            <NotificationsDropdown />
                        </div>
                        <ChatDropdown />
                    </div>
                    <div className="d-flex  justify-content-center align-items-center cursor-pointer" onClick={() => navigate('/profile-settings')}>
                        <img crossOrigin="anonymous" src={userProfileData?.full_profile_image || avatarUser} alt="User" className="mx-2 header-profile-image" />
                        <span className="fs-6 fw-bold">
                            {userProfileData?.first_name}
                            &nbsp;
                            {userProfileData?.last_name}
                        </span>
                    </div>
                </div>
            </header>
            {/* Header for desktop end */}
            {/* Header for mobile start*/}
            <header className="navbar navbar-dark  mobile-header-bg fixed-top d-block  d-lg-none">
                <div className="container-fluid">
                    <a className="navbar-brand" href="/dashboard">
                        <img crossOrigin="anonymous" className="header-logo" src={CatapaultLogo} alt="Catapault" />
                    </a>
                    <div className="d-flex align-items-center">
                        <GlobalSearch />
                        <div className="dropdown">
                            <button
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                id="notificatioDropdown"
                                className="btn text-white fs-4 p-0  position-relative border border-0"
                                onClick={handleNotificationsClick}
                                // ref={notificationIconRef}
                            >
                                <IoNotificationsOutline className="header-icon" />
                                {userProfileData?.unread_notifications > 0 && <span className="position-absolute noti-count top-0 start-100 translate-middle badge rounded-pill bg-danger">{userProfileData?.unread_notifications}</span>}
                            </button>

                            <NotificationsDropdown />
                        </div>
                        <ChatDropdown mobileView />
                        <button
                            className="navbar-toggler-custom border-none"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                            aria-label="Toggle navigation"
                        >
                            <RiMenu2Line className="text-white" />
                        </button>
                        <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                            <div className="offcanvas-header">
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body">
                                <div className="left-sidebar left-sidebar-mobile">
                                    <Asidebar />
                                </div>
                                <form className="d-flex mt-3" role="search">
                                    <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                                    <button className="btn btn-outline-success" type="submit">
                                        Search
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* Header for mobile end */}
        </>
    );
};

export default Header;
